<div class="offline_data_push_car_card_container">
  <!-- <span style="margin: auto">Nothing yet, work in-progress</span> -->
  <ng-container *ngIf="(data$ | async).length === 0">
    <div class="no_data_to_push_card">
      <span class="no_data_to_push">No offline data to push</span>
    </div>
  </ng-container>

  <div *ngFor="let data of data$ | async; let i = index">
    <div class="offline_data_push_car_card">
      <div class="disable-overlay" *ngIf="(isCurrentlyPushing$ | async) && !data.loading"></div>

      <div class="first-grid-section">
        <img
          class="car_image_container"
          [src]="data.vehicleDetails?.['vehicleFrontImage'] ?? './../../../../assets/images/gallery-placeholder-images/60636188041b3.png'"
        />
      </div>
      <div class="middle-grid-section">
        <div class="car-lock-unlock-container">
          <ng-container *ngIf="_isDeviceOnlineService.currentNetwork === 'offline'">
            <ng-container *ngIf="data.isCarLocked">
              <span (click)="unlockThisVin(data.vin)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-lock"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"
                  />
                  <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
                  <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
                </svg>
              </span>
            </ng-container>
            <ng-container *ngIf="!data.isCarLocked">
              <span (click)="lockThisVin(data.vin)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-lock-open-2"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M3 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
                  />
                  <path d="M9 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
                  <path d="M13 11v-4a4 4 0 1 1 8 0v4" />
                </svg>
              </span>
            </ng-container>
          </ng-container>
        </div>

        <div class="car_info_container">
          <p class="car_name_text">{{ data.vehicleDetails.vehicleItemCode }}</p>
          <div class="pwa_data_push_status_badge_container">
            <div class="pwa_data_push_status_badge" style="position: relative">
              <div
                class="pwa_data_push_status_badge_progress"
                [ngStyle]="{
                  width: data.apiCallsCompletionInformation.registration.completionPercentage + '%'
                }"
              ></div>
              <ng-container *ngIf="data.apiCallsCompletionInformation.registration.loading">
                <div class="loader_container" style="position: absolute; inset: 0">
                  <div class="loader"></div>
                </div>
              </ng-container>
              <span>Registration</span>
            </div>

            <div class="pwa_data_push_status_badge">
              <div
                class="pwa_data_push_status_badge_progress"
                [ngStyle]="{
                  width: data.apiCallsCompletionInformation.information.completionPercentage + '%'
                }"
              ></div>
              <ng-container *ngIf="data.apiCallsCompletionInformation.information.loading">
                <div class="loader_container">
                  <div class="loader"></div>
                </div>
              </ng-container>
              <span>Information</span>
            </div>

            <!-- <div
              [attr.data-sync-completed]="
                _syncPwaDataService.isEveryApiCallExecuted({ group: 'options', vin: data.vin })
              "
              class="pwa_data_push_status_badge"
            > -->

            <div class="pwa_data_push_status_badge">
              <div
                class="pwa_data_push_status_badge_progress"
                [ngStyle]="{
                  width: data.apiCallsCompletionInformation.options.completionPercentage + '%'
                }"
              ></div>
              <ng-container *ngIf="data.apiCallsCompletionInformation.options.loading">
                <div class="loader_container">
                  <div class="loader"></div>
                </div>
              </ng-container>
              <span>Options</span>
            </div>

            <div class="pwa_data_push_status_badge">
              <div
                class="pwa_data_push_status_badge_progress"
                [ngStyle]="{
                  width: data.apiCallsCompletionInformation.flags.completionPercentage + '%'
                }"
              ></div>
              <ng-container *ngIf="data.apiCallsCompletionInformation.flags.loading">
                <div class="loader_container">
                  <div class="loader"></div>
                </div>
              </ng-container>
              <span>Flags</span>
            </div>

            <div class="pwa_data_push_status_badge">
              <div
                class="pwa_data_push_status_badge_progress"
                [ngStyle]="{
                  width: data.apiCallsCompletionInformation.ratings.completionPercentage + '%'
                }"
              ></div>
              <ng-container *ngIf="data.apiCallsCompletionInformation.ratings.loading">
                <div class="loader_container">
                  <div class="loader"></div>
                </div>
              </ng-container>
              <span>Ratings</span>
            </div>

            <div class="pwa_data_push_status_badge">
              <div
                class="pwa_data_push_status_badge_progress"
                [ngStyle]="{
                  width: data.apiCallsCompletionInformation.gallery.completionPercentage + '%'
                }"
              ></div>
              <ng-container *ngIf="data.apiCallsCompletionInformation.gallery.loading">
                <div class="loader_container">
                  <div class="loader"></div>
                </div>
              </ng-container>
              <span>Gallery</span>
            </div>
          </div>
        </div>
      </div>
      <div class="last-grid-section">
        <button
          class="push_offline_data_button"
          (click)="syncOfflineDataForVin(data.vin)"
          [disabled]="
            _isDeviceOnlineService.currentNetwork === 'offline' ||
            data.loading ||
            data.completionPercentage >= 600
          "
        >
          <p *ngIf="data.loading" class="push_offline_data_button_text">Loading ...</p>
          <p *ngIf="!data.loading" class="push_offline_data_button_text">Push</p>
        </button>

        <button
          class="push_offline_data_button"
          (click)="setThisVinAsCurrentVin(data.vin)"
          [disabled]="
            _isDeviceOnlineService.currentNetwork === 'online' ||
            (_isDeviceOnlineService.currentNetwork === 'offline' && data.isCarLocked)
          "
        >
          <p class="push_offline_data_button_text">Edit</p>
        </button>

        <!-- <button class="push_offline_data_button" (click)="deleteEntryForThisVin(data.vin)">
          <p class="push_offline_data_button_text">Delete</p>
        </button> -->

        <button
          class="push_offline_data_button"
          (click)="openModalForDeleteEntry(template, data.vin)"
        >
          <p class="push_offline_data_button_text">Delete</p>
        </button>
      </div>
    </div>
  </div>

  <!-- <button (click)="showStateForDev()">show state</button> -->
</div>

<ng-template #template let-vin="vin">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete entry</h4>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="modalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p style="text-align: center">Are you sure you want to delete this entry?</p>

    <div class="delete-entry-button-container">
      <button class="delete-entry-button yes-button" (click)="deleteEntryForThisVin()">Yes</button>
      <button type="button" class="delete-entry-button no-button" (click)="modalRef?.hide()">
        No
      </button>
    </div>
  </div>
</ng-template>

<ng-template #duplicateVinEntryModal let-vin="vin">
  <ng-container *ngIf="duplicateVinEntryLoading.getValue()">
    <div
      style="display: flex; justify-content: center; align-items: center; width: 100%; height: 60px"
    >
      <p style="padding: 0; margin: 0; line-height: 1">Loading ...</p>
    </div>
  </ng-container>

  <ng-container *ngIf="!duplicateVinEntryLoading.getValue()">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close close pull-right"
        aria-label="Close"
        (click)="duplicateVinEntryModalRef?.hide()"
      >
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-container *ngIf="duplicateVinEntryCount.getValue() === 0">
        <p>There are no records found with this VIN. Please create new</p>
      </ng-container>

      <ng-container *ngIf="duplicateVinEntryCount.getValue() > 0">
        <p>
          There are {{ duplicateVinEntryCount.getValue() }} records found with this VIN. Would you
          like to update any record?
        </p>

        <div class="duplicate-vin-card-container">
          <ng-container *ngFor="let item of duplicateVinEntryArray.getValue(); let i = index">
            <div class="duplicate-vin-card">
              <div class="information-container">
                <span class="vin-number-text">{{ item.vinNumber }}</span>
                <span class="plate-number-text">{{ item.plateNumber }}</span>
                <span class="last-updated-text">{{ item.lastUpdatedAt }}</span>
              </div>
              <div class="button-container">
                <button
                  class="update-or-create-new-button"
                  (click)="updateEntryWithExistingVehicleId(item.vinNumber, item.vehicleId)"
                >
                  Update
                </button>
              </div>
            </div>
          </ng-container>
        </div>

        <button
          class="update-or-create-new-button"
          style="margin-top: 24px"
          (click)="syncOfflineDataForVin(currentlySelectedVin)"
        >
          Create new
        </button>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
